export default "__VITE_ASSET__B8QFVop6__"